import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { ComponentProxy, ComponentProxyDirective } from '@frontend/sports/deferred/feature/component-loader';
import { PLATFORM } from '@frontend/vanilla/ssr';
import { distinctUntilChanged } from 'rxjs';

import { BetslipIntegrationService } from '../../betslip/integration/betslip-integration.service';
import { BetslipBarComponentBindings, BetslipDigitalComponentLoaderService } from '../betslip/betslip-digital-component-loader.service';
import { BottomNavActionsService } from './bottom-nav-actions.service';

@Component({
    selector: 'ms-betslip-bar-container',
    template: `
        @if (component) {
            <ng-container *msComponentProxy="component" />
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ComponentProxyDirective],
})
export class BetslipBarContainerComponent {
    private betslipIntegration = inject(BetslipIntegrationService);
    private bottomNavActionsService = inject(BottomNavActionsService);
    private changeDetectorRef = inject(ChangeDetectorRef);
    private destroyRef = inject(DestroyRef);

    component?: ComponentProxy<BetslipBarComponentBindings>;

    private platform = inject(PLATFORM);

    constructor() {
        const betslipLoader = inject(BetslipDigitalComponentLoaderService);

        this.platform.runOnBrowser(() => {
            this.betslipIntegration.betslipBarEnabled.pipe(distinctUntilChanged(), takeUntilDestroyed(this.destroyRef)).subscribe((enabled) => {
                if (enabled) {
                    this.component = betslipLoader.getBetslipBarComponent();
                    this.component.subscribeToOutputs({
                        barClick: () => this.bottomNavActionsService.betslipToggled(),
                        myBetsClick: () => this.bottomNavActionsService.myBetsToggled(),
                    });
                } else {
                    this.component?.destroy();
                    this.component = undefined;
                }
                this.changeDetectorRef.markForCheck();
            });
        });
    }
}
